var _path, _g, _rect, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 40,
    viewBox: "0 0 197 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 40L0 40L-2.44784e-06 12L12 12L12 40Z",
    fill: "#FAE232",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29915_126953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12L-2.86102e-06 12L-3.29814e-06 7L7 1.39079e-06L12 1.90735e-06L12 12Z",
    fill: "#FAE232",
    fillOpacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 40,
    transform: "translate(12)",
    fill: "#FAE232",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185 0H197V28H185V0Z",
    fill: "#FAE232",
    fillOpacity: 0.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_29915_126953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 28H197V33L190 40H185V28Z",
    fill: "#FAE232",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29915_126953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_29915_126953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(197 40) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationHover);
export default __webpack_public_path__ + "static/media/navigation-hover.71b54ae2bd87437fc89ef8ef8ef313ee.svg";
export { ForwardRef as ReactComponent };